import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Spreadsheet } from 'react-spreadsheet';

export const ExcelPreviewModal = ({ show, data, onClose }) => {

    const handleKeyDown = (e) => {
      //There's a bug in the react-spreadsheet package
      // Where you can copy paste into read only cells
      // this prevents that
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
        e.preventDefault();
      }
    };
  
    return (
      <Modal show={show} onHide={onClose} dialogClassName="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Excel Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{ maxHeight: '35.5rem', overflowY: 'auto' }}
            onKeyDown={handleKeyDown}
          >
            <Spreadsheet
              data={data}
              onChange={() => {}} 
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  